export const DEFAULT_PACIFIC_FRANC_TO_EURO_RATE = 0.00838
